import { ChangeDetectionStrategy, Component, Input, Renderer2, computed, inject, input, AfterViewInit } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { ImageComponent, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { CookieNgrxModule } from '@teamfoster/sdk/cookie-ngrx';
import { TextUtilityModule, UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { ButtonModule } from '@teamfoster/sdk/button';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { ContentBlock, ContentBlockListInfo } from '../../models';
import { ActivatedRoute, RouterLink, RouterOutlet } from '@angular/router';
import { SlicePipe } from '@angular/common';

@Component({
  selector: 'app-content-block-anchor-nav',
  templateUrl: './content-block-anchor-nav.component.html',
  styleUrls: ['./content-block-anchor-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ResizeHtmlImagesPipe,
    CookieNgrxModule,
    TextUtilityModule,
    ButtonModule,
    FromDictionaryPipe,
    ImageComponent,
    RouterLink,
    RouterOutlet,
    SlicePipe,
  ],
  providers: [UrlRewritePipe],
})
export class ContentBlockAnchorNavComponent extends ContentBlockBaseComponent {
  private route = inject(ActivatedRoute);
  private renderer = inject(Renderer2);
  blocks = input.required<ContentBlockListInfo[]>();
  debug = input<boolean>(false);
  urlRewritePipe = inject(UrlRewritePipe);

  scrollToBlock(anchor: string) {
    if (!anchor) {
      return;
    }
    const fragment = this.urlRewritePipe.transform(anchor);

    if (this.blocks().find(i => i.anchor === fragment)) {
      const element = this.renderer.selectRootElement('#' + fragment, true);

      if (element) {
        const yOffset = 100 * -1; // Your offset value
        const yPosition = element.getBoundingClientRect().top + window.scrollY + yOffset;

        window.scrollTo({
          top: yPosition,
          behavior: 'smooth',
        });
      }
    }
  }
}
